import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Sales people should create content." />

                      
<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-should-create-content/&amp;title=Sales%20people%20should%20create%20content.&amp;summary=Sales%20people%20should%20create%20content.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-people-should-create-content/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20people%20should%20create%20content.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-should-create-content/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-should-create-content/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-people-should-create-content/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20people%20should%20create%20content.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-people-should-create-content/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header header--video" id="page-header">
    <div className="header__image" data-video-uri="https://www.youtube.com/embed/OHXCj849TBU?autoplay=1&amp;modestbranding=0&amp;rel=0&amp;showinfo=0" data-video-target="#page-header .embed-responsive" data-video-parent="#page-header">
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/Mentor-Large-Tony-Hughes.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>Career change</h3>
                        <h1>Sales people should create content.</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Tony J. Hughes</li>
                        <li>19 August 2016</li>
                        <li>3:30</li>
                    </ul>
                    <div className="header__icon play-icon">
                        <i className="icon"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>We live in the age of personal brands!</h3>
<div className="rich-text"><p>The emergence of personal branding and social selling leads to demands that salespeople need to share content of value with their target customers. This leads to the question “Should salespeople produce their own content – or is it ok to share other peoples content? In this interview Tony Hughes addresses this question.</p><p></p><p>Tony says that “buyers today expect salespeople in a business-to-business world to lead with insight, to deliver real value in the conversations”.  He goes on to say the best way to do this “is for them to research something themselves, and write something, and that will make it easier for them to carry the conversation, to have some gravitas”.</p><p>Tony goes on to say that salespeople will not survive if they don’t “create the value that funds their role”, and he controversially adds that “if you can’t write, you can’t sell”. He goes on to tell us how we can do this without breaking our back. </p></div>


  <button type="button" className="btn btn-default" data-toggle="collapse" data-target="#transcript" aria-expanded="false" aria-controls="transcript">View full transcript</button>
  <div className="collapse" id="transcript">
  <h3>Transcript</h3>
  <div className="block-paragraph"><div className="rich-text"><p><b>John:</b> Good to see you again, Tony!</p><p><b>Tony:</b> Hey, John!</p><p><b>John:</b> Hey, I’ve seen you writing a lot recently about the fact that salespeople need to write, they need to put content out there. I need to understand that more. Why?</p><p><b>Tony:</b> We live in the age of personal brands. People have always bought from those they like and trust.</p><p><b>John:</b> Totally agree.</p><p><b>Tony:</b> People buy the salesperson, before they’re going to buy what they’re representing in the company.</p><p><b>John:</b> Yes. But as a salesperson, can’t I position well with a good brand just by finding good content that other people have written, and share that with my customers?</p><p><b>Tony:</b> Well, I don’t believe that’s enough, and here’s why. Buyers today expect salespeople in a business-to-business world to lead with insight, to deliver real value in the conversations.</p><p><b>John:</b> Agree.</p><p><b>Tony:</b> People can source information easily, and everything drifts toward being a commodity, the way we sell. It’s all clichés, I know, but the way we sell is more important than what we sell. So, if we’re going to lead with insight, we can try and train salespeople to have that, but the best way for a person to learn is for them to research something themselves, and write something, and that’ll make it easier for them to carry the conversation, to have some gravitas.</p><p><b>John:</b> But that’s tough for a lot of salespeople. They don’t see themselves as writers, and nor do they find a lot of time to go away and put the thought process and the research necessary to write an article.</p><p><b>Tony:</b> This is controversial, but I think within 10 years 30% of salespeople in field business-to-business selling won’t have jobs, and the reason they won’t is they’ll fail to create the value that funds their role. I believe if you can’t write, you can’t sell; you need to have opinions on the things that you’re selling.</p><p><b>John:</b> Okay. So, let’s talk a little bit about how they can do that. You’ve got to make it easy for salespeople to write good, valuable content, don’t you?</p><p><b>Tony:</b> Yes, but that’s where marketing can help. In every organisation we need to do this in a controlled way, we need to support people well, so I think sales managers, marketing people, can actually be content editors for people. They can give them ideas, they can give them information and research, and help people create their own pieces, but then edit and support them in publishing.</p><p><b>John:</b> This also reminds me a little bit about Sue in the Sue &amp; Barry story. </p><p><b>Tony:</b> Yes, it’s a great case study you wrote.</p><p><b>John:</b> Sue was brilliant at writing articles, and putting good content that customers loved and got a lot of value out of. And when I spoke to Sue about how she goes about that, she used to  pump articles out really easily. And do you know what? She focused on existing customers, and how they created value in their own business. Nothing to do with her product or service, although that was obviously part of how the customer actually created that value, but she took case studies.</p><p><b>Tony:</b> Salespeople need to be good at telling great, true stories that are relevant to potential buyers, that put them in the picture. And customers are often reluctant to put their own brand out there in doing case studies and endorsements of suppliers, but the salesperson can still write up the case study and just change the names. That’s exactly what you did in your video that I saw.</p><p><b>John:</b> That’s right. So the bottom line is, you’re saying if we want to progress in a sales career, we have to learn how to do this – it’s vital for the future of the way we sell.</p><p><b>Tony:</b> Yes. And sales managers and management need to let go of the problem in their mind of people building their own brand – it’s always been that way.</p><p><b>John:</b> Great advice, Tony, and I look forward to the next time we talk!</p><p><b>Tony:</b> Thanks, John!</p></div></div>
  </div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Tony Hughes" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Tony-Hughes.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Tony J. Hughes</h4>
        <p>MD of RSVPselling</p>
        <Link to="solutions/find-a-mentor/tony-j-hughes" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>Tony Hughes is an international speaker and best selling author with 30
years of sales leadership experience. He is ranked as the most influential
person in professional selling within Asia-Pacific by Top Sales Magazine and
teaches 'modernized selling' within the MBA program at the University of
Technology, Sydney. Tony is also the ‘most read’ LinkedIn Author globally. <br/></p></div>
<Link to="solutions/find-a-mentor/tony-j-hughes" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-should-create-content/&amp;title=Sales%20people%20should%20create%20content.&amp;summary=Sales%20people%20should%20create%20content.&amp;source=https%3A//salestribe.com/knowledge-centre/insights/sales-people-should-create-content/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Sales%20people%20should%20create%20content.&amp;url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-should-create-content/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/sales-people-should-create-content/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/sales-people-should-create-content/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Sales%20people%20should%20create%20content.&amp;body=https%3A//salestribe.com/knowledge-centre/insights/sales-people-should-create-content/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/can-robots-and-ai-actually-help-you-enhance-your-sales-career" className="card card--article">
                <div className="card__thumb">
                    <img alt="Future robot" className="card__image" height="404" src="../../../media/images/article-future-robot.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">Career change</p>
                        <h3 className="card__title"><strong>Can Robots and AI actually help you to enhance your sales career?</strong></h3>
                    </header>
                    <p>Sales people who embrace working with bots and leverage advanced technology will be well positioned to survive the big cull that his now coming.</p>
                    <footer><p className="card__author">Tony J. Hughes</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/driving-forces-change" className="card card--article">
                <div className="card__thumb">
                    <img alt="Challenge thinker" className="card__image" height="404" src="../../../media/images/article-challenge-thinker.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">Career change</p>
                        <h3 className="card__title"><strong>The driving forces of change:</strong></h3>
                    </header>
                    <p>The 5 Forces of &#39;change&#39; for Sales People</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/personal-branding-case-study" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Cian Mcloughlin" className="card__image" height="404" src="../../../media/images/Mentor-Large-Cian-Mcloughlin.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">7:22</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">Career change</p>
                        <h3 className="card__title"><strong>A personal branding case study.</strong></h3>
                    </header>
                    <p>You are who the internet says you are!</p>
                    <footer><p className="card__author">Cian Mcloughlin</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>

      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 